import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { cn } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var BaseCell = function BaseCell(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-flex tw-items-center tw-gap-1.2', className)
  }, props));
};